import { Component, OnInit, Input } from '@angular/core';
import { SafeUrl } from "@angular/platform-browser";

import { 
    IonAvatar
} from '@ionic/angular/standalone';

import { AgencyService } from '@app/services';

export class OperationLogo{
    operation: string;
    logo?: string|SafeUrl;
    constructor(operation: string, logo?: string|SafeUrl){
        this.operation = operation;
        this.logo = logo;
    }
}

@Component({
    selector: 'app-operation-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    imports: [IonAvatar]
})
export class OperationLogoComponent  implements OnInit {

    @Input({alias : 'operation', required : true}) operationLogo: OperationLogo;
    @Input({alias : 'size', required : false}) sizeLogo: 'big'|'medium'|'small' = 'medium';
    @Input({alias : 'withMarginRight', required : false}) withMarginRight: boolean = true;

//    defaultLogo: string = this.agencyService.getAgencyConfigData().logo;
    defaultLogo: string = '/assets/imgs/logo_marving_short.jpg';

    constructor(
        private agencyService: AgencyService
    ) { }

    ngOnInit() {}

    getUrlLogo(): string|SafeUrl{
        return (this.operationLogo.logo !== undefined ? this.operationLogo.logo : this.defaultLogo); 
    }
    
    onImgError(event: any){
        event.target.src = this.defaultLogo;
    }
}
